import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const TaxSlice = createSlice({
    name: "Tax",
    initialState: {
        chargeType: "",
        vatRate: 0,
        serviceRate: 0,
        stateRate: 0,
        hideTax: "",
        sumOfTax: 0,
        incTotal: 0,
        exclTotal: 0,
        inclusiveTax: 0,
        excluasiveTax: 0,
    },
    reducers: {
        setVatRate: (state, action) => {
            state.vatRate = action.payload;
        },
        setServiceRate: (state, action) => {
            state.serviceRate = action.payload;
        },
        setStateRate: (state, action) => {
            state.stateRate = action.payload;
        },
        setHideTax: (state, action) => {
            state.hideTax = action.payload;
        },
        setChargeType: (state, action) => {
            state.chargeType = action.payload;
        },
        setSumOfTax: (state, action) => {
            state.sumOfTax = action.payload;
        },
        setInclusiveTotal: (state, action) => {
            state.incTotal = action.payload;
        },
        setExclusiveTotal: (state, action) => {
            state.exclTotal = action.payload;
        },
        setInclusiveTax: (state, action) => {
            state.incTax = action.payload;
        },
        setExclusiveTax: (state, action) => {
            state.exclTax = action.payload;
        }
    },
});

export const TaxActions = TaxSlice.actions;

export default TaxSlice;